module.exports = __webpack_public_path__ + "static/img/product01.f179c29f.png";